import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { documentTypeFilingActionApi } from '../../utilities/api';
import { DocumentTypeFilingAction } from '../../utilities/interfaces/DocumentTypeFilingAction';

interface documentTypeFilingActionState {
  filingActions: DocumentTypeFilingAction[];
}

const initialState: documentTypeFilingActionState = {
  filingActions: [],
};

const documentTypeFilingActionSlice = createSlice({
  name: 'documentTypeFilingAction',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getFilingActionsById.fulfilled, (state, action: any) => {
      state.filingActions = action.payload;
    });
  },
});

export const getFilingActionsById = createAsyncThunk(
  'stateDocumentTypeFilingAction/getFilingActionById',
  async (id: number) => {
    const response = await documentTypeFilingActionApi.getById(id);
    return response;
  }
);

export default documentTypeFilingActionSlice.reducer;
